export default __webpack_public_path__ + "static/defending-975f1caf2c4e4bdcbf591ab5d8132d7a.svg";